import React from 'react';
import { Observe } from 'rewire-core';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Refresh';
import { makeStyles } from '@material-ui/core/styles';
import { StyleType } from '../utility/styles';
import MainContentToolbar from '../main-navigation/MainContentToolbar';
import Breadcrumbs from '../main-navigation/Breadcrumbs';
import GridLayout from './GridLayout';
import Loader from '../ui/Loader';
import SettingsModel, { If } from './SettingsModel';
import { useCardStyle } from './UdfEditor';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import inviteDialogModel from '../side-navigation/InviteDialogModel';
import { FilterMenu, hasChanges, SortMenu, DisplayMenu, pageState, settingsGridModel, oldSelectCells } from './DefaultSettingsView';
import CardLayout from './CardLayout';

const useItemsPanelViewStyles = makeStyles((_theme) => ({
  left: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    overflow: 'auto',
    justifyContent: 'flex-start',
  },
  right: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '7px',
  },
  addButton: {
    textTransform: 'none',
    minWidth: '0px',
    flex: '0 0 auto',
    marginRight: '10px',
    '&:last-child': {
      marginRight: '0px',
    },
  },
}));

const UserSettingsItemsPanelView = ({
  settings,
  refresh,
  classes,
}: { settings: SettingsModel; refresh: () => void; classes?: StyleType<typeof useCardStyle> }) => {
  const itemsClasses = useItemsPanelViewStyles();

  return (
    <>
      <MainContentToolbar>
        <div className={itemsClasses.left}>
          <Breadcrumbs />
        </div>
        <div className={itemsClasses.right}>
          <Observe
            render={() => (
              <Button
                className={itemsClasses.addButton}
                variant="contained"
                onClick={() => inviteDialogModel.load()}
                disabled={hasChanges() || !settings.canAddItem()}
              >
                <Icon className="add">{'add'}</Icon>
                {'Invite User'}
              </Button>
            )}
          />
          <IconButton onClick={refresh} aria-label="Refresh">
            <RefreshIcon />
          </IconButton>
          <FilterMenu settings={settings} />
          <SortMenu settings={settings} />
          <DisplayMenu />
        </div>
      </MainContentToolbar>
      <Observe>
        {() => (
          <Loader loading={settings.isLoading}>
            <Observe
              render={() => (
                <If
                  condition={pageState.mode === 'grid'}
                  then={() => (
                    <GridLayout settings={settings} classes={classes} grid={settingsGridModel} oldSelect={oldSelectCells} />
                  )}
                  otherwise={() => <CardLayout settings={settings} classes={classes} />}
                />
              )}
            />
          </Loader>
        )}
      </Observe>
    </>
  );
};

export default UserSettingsItemsPanelView;
